<div class="inner">
  <!-- Bids books: Stash + PunksMarket (separate pagination per platform) -->
  <ng-container *ngIf="bidsSectionEnabled && !isRedirecting && (marketType$ | async) === 'bids'">
    <div class="bids-platform-tabs" *ngIf="stashBidsEnabled && punksmarketBidsEnabled">
      <button
        type="button"
        class="platform-tab"
        [class.active]="bidsPlatformTab === 'stash'"
        (click)="switchBidsPlatformTab('stash')">
        Stash bids
      </button>
      <button
        type="button"
        class="platform-tab"
        [class.active]="bidsPlatformTab === 'punksmarket'"
        (click)="switchBidsPlatformTab('punksmarket')">
        PunksMarket bids
      </button>
    </div>

    <section class="stash-bids-section" *ngIf="bidsPlatformTab === 'stash' && stashBidsEnabled">
      <div class="section-title-row">
        <h2 class="section-title">Stash Bids</h2>
        <div class="toggle-wrapper inline-archive-toggle">
          <div class="sales-only-toggle" (click)="onDisplayArchivedBidsToggle()">
            <div class="label">Hide archived bids</div>
            <div class="toggle" [class.on]="!displayArchivedBids">
              <div></div>
            </div>
          </div>
        </div>
      </div>
      <h3 class="section-subtitle">All bids</h3>

      <div *ngIf="bidDeepLinkLoading || bidDeepLinkError" class="bid-deep-link-banner">
        <div *ngIf="bidDeepLinkLoading" class="bid-deep-link-loading">
          <app-loader></app-loader>
          <span>Loading bid from link…</span>
        </div>
        <div *ngIf="!bidDeepLinkLoading && bidDeepLinkError" class="bid-deep-link-error">
          <p class="error-message">{{ bidDeepLinkError }}</p>
          <div class="bid-deep-link-actions">
            <button type="button" class="retry-btn" (click)="retryBidDeepLink()">Retry</button>
            <button type="button" class="dismiss-deep-link-btn" (click)="clearBidDeepLinkError()">Dismiss</button>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="stashBidsLoading" class="loading-state">
        <app-loader></app-loader>
        <p>Loading bids...</p>
      </div>

      <!-- Error State -->
      <div *ngIf="stashBidsError && !stashBidsLoading" class="error-state">
        <p class="error-message">{{ stashBidsError }}</p>
        <button class="retry-btn" (click)="loadAllStashBids()">Retry</button>
      </div>

      <!-- Stash Bids Table -->
      <ng-container *ngIf="!stashBidsLoading && !stashBidsError">
        <div class="bids-table-wrapper">
          <table class="bids-table">
            <thead>
              <tr>
                <th 
                  class="sortable-header"
                  [class.sorted]="isColumnSorted('source')">
                  <div class="header-content">
                    <span class="header-text" (click)="onStashBidsSort('source')">Source</span>
                    <span class="sort-icon" *ngIf="isColumnSorted('source')" (click)="onStashBidsSort('source')">{{ getSortIcon('source') }}</span>
                    <button 
                      class="filter-icon"
                      [class.active]="isFilterActive('source')"
                      (click)="toggleFilter('source'); $event.stopPropagation()"
                      type="button">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                      </svg>
                    </button>
                  </div>
                </th>
                <th 
                  class="sortable-header"
                  [class.sorted]="isColumnSorted('bidder')">
                  <div class="header-content">
                    <span class="header-text" (click)="onStashBidsSort('bidder')">Bidder</span>
                    <span class="sort-icon" *ngIf="isColumnSorted('bidder')" (click)="onStashBidsSort('bidder')">{{ getSortIcon('bidder') }}</span>
                    <button 
                      class="filter-icon"
                      [class.active]="isFilterActive('bidder')"
                      (click)="toggleFilter('bidder'); $event.stopPropagation()"
                      type="button">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                      </svg>
                    </button>
                  </div>
                </th>
                <th 
                  class="sortable-header"
                  [class.sorted]="isColumnSorted('expires')"
                  (click)="onStashBidsSort('expires')">
                  <div class="header-content">
                    <span class="header-text">Expires</span>
                    <span class="sort-icon" *ngIf="isColumnSorted('expires')">{{ getSortIcon('expires') }}</span>
                  </div>
                </th>
                <th 
                  class="amount-header sortable-header"
                  [class.sorted]="isColumnSorted('amount')">
                  <div class="header-content">
                    <span class="header-text" (click)="onStashBidsSort('amount')">Amount</span>
                    <span class="sort-icon" *ngIf="isColumnSorted('amount')" (click)="onStashBidsSort('amount')">{{ getSortIcon('amount') }}</span>
                    <button 
                      class="filter-icon"
                      [class.active]="isFilterActive('amount')"
                      (click)="toggleFilter('amount'); $event.stopPropagation()"
                      type="button">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                      </svg>
                    </button>
                  </div>
                </th>
                <th class="bid-type-header sortable-header">
                  <div class="header-content">
                    <span class="header-text">Bid Type</span>
                    <button 
                      class="filter-icon"
                      [class.active]="isFilterActive('bidType')"
                      (click)="toggleFilter('bidType'); $event.stopPropagation()"
                      type="button">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                      </svg>
                    </button>
                  </div>
                </th>
                <th class="status-header sortable-header">
                  <div class="header-content">
                    <span class="header-text">Status</span>
                    <button
                      class="filter-icon"
                      [class.active]="isFilterActive('status')"
                      (click)="toggleFilter('status'); $event.stopPropagation()"
                      type="button">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                      </svg>
                    </button>
                  </div>
                </th>
                <th class="action-header">Actions</th>
              </tr>
              <tr class="filter-row" *ngIf="activeFilter">
                <th colspan="7" class="filter-header-cell">
                  <div class="filter-dropdown">
                    <!-- Source Filter -->
                    <div *ngIf="activeFilter === 'source'" class="filter-content">
                      <div class="filter-label">Source:</div>
                      <ng-select
                        #sourceSelect
                        [(ngModel)]="tempFilters.source"
                        [items]="availableSources"
                        bindLabel="label"
                        bindValue="value"
                        [searchable]="false"
                        [clearable]="false"
                        (change)="applyStashBidsFilters()">
                      </ng-select>
                      <button 
                        class="clear-filter-btn" 
                        type="button" 
                        (click)="clearFilter('source')"
                        [disabled]="!isFilterActive('source')">
                        Clear
                      </button>
                    </div>

                    <!-- Bidder Filter -->
                    <div *ngIf="activeFilter === 'bidder'" class="filter-content">
                      <div class="filter-label">Bidder:</div>
                      <div class="input-wrapper">
                        <input 
                          #bidderInput
                          type="text"
                          class="filter-input"
                          placeholder="Address, ENS name, or partial match"
                          [(ngModel)]="tempFilters.bidder"
                          (keydown.enter)="applyStashBidsFilters()"
                          autocapitalize="off"
                          autocorrect="off"
                          autocomplete="off"
                          spellcheck="false">
                      </div>
                      <button class="apply-filter-btn" type="button" (click)="applyStashBidsFilters()">Go</button>
                      <button 
                        class="clear-filter-btn" 
                        type="button" 
                        (click)="clearFilter('bidder')"
                        [disabled]="!isFilterActive('bidder')">
                        Clear
                      </button>
                    </div>

                    <!-- Amount Filter -->
                    <div *ngIf="activeFilter === 'amount'" class="filter-content">
                      <div class="filter-label">Amount:</div>
                      <div class="amount-filters">
                        <div class="input-wrapper">
                          <input 
                            #amountMinInput
                            type="number"
                            class="filter-input"
                            placeholder="Min (ETH)"
                            step="0.01"
                            [(ngModel)]="tempFilters.amountMin"
                            (keydown.enter)="applyStashBidsFilters()"
                            autocapitalize="off"
                            autocorrect="off"
                            autocomplete="off"
                            spellcheck="false">
                        </div>
                        <div class="input-wrapper">
                          <input 
                            #amountMaxInput
                            type="number"
                            class="filter-input"
                            placeholder="Max (ETH)"
                            step="0.01"
                            [(ngModel)]="tempFilters.amountMax"
                            (keydown.enter)="applyStashBidsFilters()"
                            autocapitalize="off"
                            autocorrect="off"
                            autocomplete="off"
                            spellcheck="false">
                        </div>
                      </div>
                      <button class="apply-filter-btn" type="button" (click)="applyStashBidsFilters()">Go</button>
                      <button 
                        class="clear-filter-btn" 
                        type="button" 
                        (click)="clearFilter('amount')"
                        [disabled]="!isFilterActive('amount')">
                        Clear
                      </button>
                    </div>

                    <!-- Bid Type Filter -->
                    <div *ngIf="activeFilter === 'bidType'" class="filter-content">
                      <div class="filter-label">Bid Type:</div>
                      <ng-select
                        #bidTypeSelect
                        [(ngModel)]="tempFilters.bidType"
                        [items]="availableBidTypes"
                        bindLabel="label"
                        bindValue="value"
                        [searchable]="false"
                        [clearable]="false"
                        (change)="applyStashBidsFilters()">
                      </ng-select>
                      <div class="toggle-wrapper">
                        <div class="sales-only-toggle" (click)="tempFilters.confidential = !tempFilters.confidential; applyStashBidsFilters()">
                          <div class="label">Show Confidential Only</div>
                          <div class="toggle" [class.on]="tempFilters.confidential">
                            <div></div>
                          </div>
                        </div>
                      </div>
                      <button 
                        class="clear-filter-btn" 
                        type="button" 
                        (click)="clearFilter('bidType')"
                        [disabled]="!isFilterActive('bidType')">
                        Clear
                      </button>
                    </div>

                    <!-- Status Filter -->
                    <div *ngIf="activeFilter === 'status'" class="filter-content">
                      <div class="filter-label">Status:</div>
                      <ng-select
                        #statusSelect
                        [(ngModel)]="tempFilters.status"
                        [items]="availableBidStatuses"
                        bindLabel="label"
                        bindValue="value"
                        [searchable]="false"
                        [clearable]="false"
                        (change)="applyStashBidsFilters()">
                      </ng-select>
                      <button
                        class="clear-filter-btn"
                        type="button"
                        (click)="clearFilter('status')"
                        [disabled]="!isFilterActive('status')">
                        Clear
                      </button>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="stashBidsTotalPages > 0">
                <tr *ngFor="let bid of getPaginatedStashBids(); let i = index" [class.highest-bid]="stashBidsCurrentPage === 1 && i === 0">
                <td class="source-cell">
                  {{ bid.source || 'Stash' }}
                  <!-- Debug mode icon -->
                  <div 
                    *ngIf="!environment.production" 
                    class="debug-icon"
                    (click)="copyBidJson(bid, $event)"
                    [title]="'Bid ID: ' + bid.id">
                    (i)
                  </div>
                </td>
                <td class="bidder-cell">
                  <div class="bidder-cell-wrapper">
                    <app-address-avatar [address]="bid.bidder_address"></app-address-avatar>
                    <div class="bidder-addresses">
                      <div class="bidder-address-row">
                        <a [routerLink]="['/', 'user', bid.bidder_address]">
                          <app-wallet-address [address]="bid.bidder_address"></app-wallet-address>
                        </a>
                      </div>
                      <div class="stash-address-row" *ngIf="bid.stashAddress">
                        <span class="stash-prefix">L&nbsp;</span>
                        <a
                          [href]="'https://etherscan.io/address/' + bid.stashAddress"
                          target="_blank"
                          rel="noopener noreferrer">
                          <app-wallet-address [address]="bid.stashAddress" [maxVisibleChars]="14"></app-wallet-address>
                        </a>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="expires-cell">
                  <span>{{ bid.expires_at ? (bid.expires_at | date) : '-' }}</span>
                  <span 
                    *ngIf="bid.expires_at"
                    tippy
                    [options]="{
                      content: (bid.expires_at | date:'short') || '',
                      placement: 'top',
                      theme: 'punks'
                    }"
                    class="detail-icon">
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      height="14" 
                      viewBox="0 0 24 24" 
                      width="14" 
                      fill="currentColor"
                      style="opacity: 0.6; margin-left: 0.55rem; transform: translate(0.2rem, 0.1rem) scale(1.2); cursor: help;">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                    </svg>
                  </span>
                </td>
                <td class="bid-amount-cell">{{ bid.bid_amount_eth | number:'1.2-2' }}&nbsp;ETH</td>
                <td class="bid-type-cell">
                  <div>
                    <div *ngIf="bid.confidential" class="confidential-pill" title="Confidential bid">
                      <svg style="transform: scale(1.4);" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/></svg>
                      <span>Confidential</span>
                    </div>
                    <div
                      *ngIf="bid.stash_funded === 0"
                      class="unfunded-pill"
                      title="Stash balance is below this bid amount">
                      unfunded
                    </div>
                    <span
                      class="bid-type-pill"
                      [class.trait]="bid.bidType === 'trait'"
                      [class.custom]="bid.bidType === 'custom'"
                      [class.owner]="bid.bidType === 'owner'"
                      [class.collection]="bid.bidType === 'collection'">
                      {{ bid.bidTypeLabel || (bid.bidType === 'trait' ? 'Trait Bid' : bid.bidType === 'owner' ? 'Owner Bid' : bid.bidType === 'custom' ? 'Custom Bid' : 'Collection Bid') }}
                    </span>
                    <ng-container *ngIf="bid.bidType === 'owner' && bid.ownerAddress">
                      <div class="tags-list">
                        <a class="tag-pill owner-link" [routerLink]="['/', 'user', bid.ownerAddress]">
                          Owner: <app-wallet-address [address]="bid.ownerAddress"></app-wallet-address>
                        </a>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="bid.bidType !== 'custom' && bid.bidType !== 'owner'">
                      <div class="tags-list" *ngIf="bid.decodedTags?.length; else traitTagFallback">
                        <span class="tag-pill" *ngFor="let tag of bid.decodedTags">{{ tag }}</span>
                      </div>
                      <ng-template #traitTagFallback>
                        <div class="tags-list" *ngIf="bid.tag">
                          <span class="tag-pill">{{ bid.tag }}</span>
                        </div>
                      </ng-template>
                    </ng-container>
                    <ng-container *ngIf="(bid.bidType === 'custom' || bid.bidType === 'trait') && (bid.punkPreviewIds?.length || bid.punk_indices_count)">
                      <div class="custom-bid-punks-frise">
                        <a
                          *ngFor="let punkId of bid.punkPreviewIds; trackBy: trackByPunkId"
                          class="punk-frise-item"
                          [routerLink]="['/', 'details', punkId]"
                          (click)="$event.stopPropagation()">
                          <img
                            [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (punkId | tokenIdParse) + '.svg'"
                            [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
                            width="24"
                            height="24"
                            [alt]="'Punk ' + punkId" />
                        </a>
                        <div
                          *ngIf="bid.punkExtraCount && bid.punkExtraCount > 0"
                          class="punk-frise-item punk-count-item"
                          [title]="'+' + bid.punkExtraCount + ' more'">
                          +{{ bid.punkExtraCount }}
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </td>
                <td class="status-cell">
                  <div class="status-cell-content">
                    <span
                      class="status-pill"
                      [class.active]="bid.uiStatusFilter === 'active'"
                      [class.expired]="bid.uiStatusFilter === 'expired'"
                      [class.cancelled]="bid.uiStatusFilter === 'cancelled'">
                      {{ bid.uiStatusLabel || '-' }}
                    </span>
                  </div>
                </td>
                <td class="action-cell">
                  <div class="action-buttons">
                    <button
                      class="copy-bid-btn icon-btn"
                      (click)="openCopyBidModal(bid); $event.stopPropagation()"
                      tippy
                      [options]="{ content: 'Clone stash bid', placement: 'bottom', theme: 'punks', delay: [200, 400] }">
                      <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16" fill="currentColor">
                        <path d="M480-240h80v-120h120v-80H560v-120h-80v120H360v80h120v120ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z"/>
                      </svg>
                    </button>
                    <button 
                      class="detail-bid-btn icon-btn"
                      (click)="onShowBidDetails(bid)"
                      tippy
                      [options]="{ content: 'Bid details', placement: 'bottom', theme: 'punks', delay: [200, 400] }">
                      <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16" fill="currentColor">
                        <path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Z"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
              </ng-container>
              <tr *ngIf="stashBidsTotalPages === 0" class="empty-state-row">
                <td colspan="7" class="empty-state-cell">
                  <p>No results for this filter combination.</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Last bid fetch timestamp -->
        <div class="last-bid-fetch" *ngIf="formattedLastBidFetch" style="text-align: right; font-size: 1.2rem; color: #666; margin-right: 0.2rem; margin-bottom: 0.5rem;">
          Last updated: {{ formattedLastBidFetch }}
        </div>

        <!-- Pagination -->
        <div class="pagination" *ngIf="stashBidsTotalPages > 1">
          <button 
            class="page-btn"
            [class.disabled]="stashBidsCurrentPage === 1"
            (click)="goToStashBidsPage(stashBidsCurrentPage - 1)"
            [disabled]="stashBidsCurrentPage === 1">
            ‹
          </button>
          <ng-container *ngFor="let item of stashBidsPaginationItems">
            <span *ngIf="item.kind === 'ellipsis'" class="page-ellipsis" aria-hidden="true">…</span>
            <span
              *ngIf="item.kind === 'page'"
              class="page-number"
              [class.active]="stashBidsCurrentPage === item.n"
              (click)="goToStashBidsPage(item.n)">
              {{ item.n }}
            </span>
          </ng-container>
          <button 
            class="page-btn"
            [class.disabled]="stashBidsCurrentPage === stashBidsTotalPages"
            (click)="goToStashBidsPage(stashBidsCurrentPage + 1)"
            [disabled]="stashBidsCurrentPage === stashBidsTotalPages">
            ›
          </button>
        </div>
      </ng-container>
    </section>

    <section class="stash-bids-section punksmarket-bids-section" *ngIf="bidsPlatformTab === 'punksmarket' && punksmarketBidsEnabled">
      <div class="section-title-row">
        <h2 class="section-title">PunksMarket Bids</h2>
      </div>
      <h3 class="section-subtitle">On-chain criteria bids</h3>

      <div *ngIf="pmBidsLoading" class="loading-state">
        <app-loader></app-loader>
        <p>Loading PunksMarket bids…</p>
      </div>
      <div *ngIf="pmBidsError && !pmBidsLoading" class="error-state">
        <p class="error-message">{{ pmBidsError }}</p>
        <button type="button" class="retry-btn" (click)="loadPunksmarketBids()">Retry</button>
      </div>
      <ng-container *ngIf="!pmBidsLoading && !pmBidsError">
        <app-stash-bids-table
          [bids]="pmBidsTableRows"
          [showFilters]="false"
          [showPagination]="false"
          [preserveServerOrder]="true"
          [showExpiresColumn]="false">
        </app-stash-bids-table>
        <div class="pagination" *ngIf="pmBidsTotalPages > 1">
          <button
            type="button"
            class="page-btn"
            [disabled]="pmBidsCurrentPage === 1"
            (click)="goToPmBidsPage(pmBidsCurrentPage - 1)">
            ‹
          </button>
          <ng-container *ngFor="let item of pmBidsPaginationItems">
            <span *ngIf="item.kind === 'ellipsis'" class="page-ellipsis">…</span>
            <span
              *ngIf="item.kind === 'page'"
              class="page-number"
              [class.active]="pmBidsCurrentPage === item.n"
              (click)="goToPmBidsPage(item.n)">
              {{ item.n }}
            </span>
          </ng-container>
          <button
            type="button"
            class="page-btn"
            [disabled]="pmBidsCurrentPage === pmBidsTotalPages"
            (click)="goToPmBidsPage(pmBidsCurrentPage + 1)">
            ›
          </button>
        </div>
      </ng-container>
    </section>
  </ng-container>

  <!-- Bid Details Modal -->
  <app-bid-details-modal
    [isActive]="bidDetailsModalActive"
    [bid]="selectedBidForDetails"
    (closed)="closeBidDetailsModal()"
    (copyBid)="openCopyBidModal($event)">
  </app-bid-details-modal>

  <!-- Bid Copy Confirmation Modal -->
  <app-bid-copy-confirmation-modal
    [isActive]="copyConfirmationModalActive"
    [punkIds]="copyConfirmationPunkIds"
    (confirmed)="onCopyConfirmed()"
    (cancelled)="onCopyCancelled()">
  </app-bid-copy-confirmation-modal>

  <!-- Bid Creation Modal (Copy bid) -->
  <app-bid-creation-modal
    [isActive]="bidCreationModalActive"
    [bidType]="copyFromBidPayload?.bidType ?? 'collection'"
    [ownerAddress]="copyFromBidPayload?.ownerAddress ?? null"
    [punkIndices]="copyFromBidPayload?.punkIndices ?? []"
    [selectedPunkIds]="copyFromBidPayload?.selectedPunkIds ?? []"
    [activeTraits]="copyFromBidPayload?.activeTraits ?? []"
    [filterTag]="copyFromBidPayload?.filterTag ?? ''"
    [copyFromBid]="copyFromBidPayload"
    (modalClosed)="closeCopyBidModal()"
    (bidCreated)="onCopyBidCreated()">
  </app-bid-creation-modal>

  <!-- Current Bids Section (punk-grid-view) -->
  <ng-container *ngIf="!isRedirecting && (punkData$ | async) as data">
    <app-punk-grid-view
      [punkData]="data"
      [viewType]="'market'"
      [sort]="activeSort"
      [limit]="200"
      [address]="route.snapshot.queryParams.address"
      [marketType]="(route.params | async)?.marketType || 'all'">
    </app-punk-grid-view>
  </ng-container>
</div>
